import { Link } from "react-router-dom"
import AuthLayout from "../../../components/layout/AuthLayout"
import Button from "../../../components/ui/Button"
import FormInput from "../../../components/layout/FormInput"

export default function CompanySignUpInformation() {
  return (
    <AuthLayout
      title="Creating an account on Oshimed requires prior authorization"
      subtitle="If you wish to use the platform, please submit a request using the form below."
      logoSrc="/img/logo.png"
      imageSrc="/img/Oshimed sign in image - earth.png"
      formWidth="half"
      logoPosition = "top"
      contentPadding="small"
      maxWidth="full"
      textAlignment="center"
    >
      {/* Main Form */}
      <form className="space-y-4 w-full max-w-4xl mx-auto">
        {/* First row - Company name and Email */}
        <div className="flex flex-row space-x-6">
          <div className="flex-1">
            <FormInput label="Company name" id="company" name="company" type="text" placeholder="Oshimed SA" required />
          </div>

          <div className="flex-1">
            <FormInput
              label="Email address"
              id="email"
              name="email"
              type="email"
              placeholder="name@mail.com"
              required
            />
          </div>
        </div>

        {/* Second row - First name and Last name */}
        <div className="flex flex-row space-x-6">
          <div className="flex-1">
            <FormInput
              label="First name"
              id="firstName"
              name="firstName"
              type="text"
              placeholder="First Name"
              required
            />
          </div>

          <div className="flex-1">
            <FormInput label="Last Name" id="lastName" name="lastName" type="text" placeholder="Last Name" required />
          </div>
        </div>

        {/* Third row - Additional comments */}
        <div className="grid grid-cols-1 gap-4 w-full">
          <FormInput
            label="Additional Comments"
            id="additionalComments"
            name="additionalComments"
            type="text"
            placeholder="Optional"
            required
          />
        </div>

        {/* Send button */}
        <div className="mt-6 mb-8 flex justify-center">
          <Button
            type="submit"
            variant="login"
            className="bg-button-login text-white font-medium py-3 ]"
          >
            Send
          </Button>
        </div>
      </form>
      <div className="h-6"></div>

      {/* Terms and conditions */}
      <div className="mt-10 text-center">
        <p className="font-bold">
          By creating an account, you agree to Oshimed's{" "}
          <Link to="/conditions-of-use" className="text-linkColor font-semibold hover:underline">
            Conditions of use
          </Link>
        </p>
      </div>
    </AuthLayout>
  )
}
